<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'80px'" :get-action="queryApi" :serial="serial" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.common.status')" prop="prohibits">
            <BjSelectLov v-model="queryParams.prohibits" :option-list="STATUS_ENABLED_NUM" :clearable="false" :placeholder="$t('AccountManagement.common.status')" @change="changeProhibit"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('WorkorderType.table.InquiryType')" prop="consultName">
            <BjSelectLov v-model="queryParams.consultName" :option-list="consultNameList" :clearable="false" :placeholder="$t('WorkorderType.table.InquiryType')"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="addType">{{ $t('WorkorderType.Addwork') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <el-tag v-else-if="col.prop === 'prohibits'" :type="scope.row.prohibits ? 'success' : 'info'">{{ $t(STATUS_ENABLED_NUM.bjGet(scope.row.prohibits)) }}</el-tag>
              <el-tag v-else-if="col.prop === 'requiresAttach'" :type="scope.row.requiresAttach ? 'success' : 'info'">{{ $t(STATUS_YES_NUM.bjGet(scope.row.requiresAttach)) }}</el-tag>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-dropdown v-hasDropdownChildren size="mini" @command="command($event, props.row)">
                <span class="el-dropdown-link">
                  {{ $t('table.operationText') }}<i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="!props.row.prohibits" :command="$t('enableText')">{{ $t('enableText') }}</el-dropdown-item>
                  <el-dropdown-item v-else :command="$t('disableText')">{{ $t('disableText') }}</el-dropdown-item>
                  <el-dropdown-item v-if="!props.row.prohibits" :command="$t('editText')">{{ $t('editText') }}</el-dropdown-item>
                  <el-dropdown-item :command="$t('WorkorderType.common.Log')">{{ $t('RoleManagement.common.Log') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <el-dialog :title="$t('WorkorderType.Addwork')" :visible.sync="addDialogVisible" width="800px" :before-close="handleClose">
      <el-form ref="form" :model="form" status-icon :rules="rules" label-width="250px" label-position="top">
        <el-form-item :label="$t('WorkorderType.table.InquiryType')" prop="consultName">
          <BjSelectLov v-model="form.consultName" :option-list="consultNameList" :clearable="false" :placeholder="$t('WorkorderType.table.InquiryType')"/>
        </el-form-item>
        <el-form-item :label="$t('WorkorderType.table.ServiceType')" prop="name">
          <BjInput v-model="form.name" :placeholder="$t('inputText')" />
        </el-form-item>
        <el-form-item :label="$t('WorkorderType.table.TypeErrordescription')" prop="remark">
          <BjInput v-model="form.remark" type="textarea" :maxlength="MAX_LENGTH.NORMAL_REMARK" show-word-limit :placeholder="$t('inputText')" />
        </el-form-item>
        <el-form-item :label="$t('WorkorderType.table.Feeitems')" prop="pay">
          <BjInput v-model="form.pay" :disabled="true" :placeholder="$t('inputText')">
            <template slot="append">
              <el-button @click="openSKU">{{ $t('chooseText') }}</el-button>
            </template>
          </BjInput>
          <!-- <BjSelectLov v-model="payList" :option-list="chargeItemList" multiple :placeholder="$t('chooseText')" /> -->
        </el-form-item>
        <el-form-item :label="$t('WorkorderType.table.attachments')">
          <BjRadioLov v-model="form.requiresAttach" :option-list="STATUS_YES_NUMBER" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="submitForm('form')">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
    <log-list ref="logListRef"></log-list>

    <BjDialogList ref="dialogListChangeItem" width="80%"
      :config="$BjDialogListConfig.chargeItemDefault('route.BusinessBillingCategories', {defaultQuery: {tags:'Ticket1,Ticket2,Free', tenantId: $store.getters.tenantId}})"
      :resetBtnHide="true" :searchBtnHide="true"
      multiple @confirm="onAddChargeItemConfirm"
    />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { workorderApi } from '@/api';
import { STATUS_ENABLED_NUM, STATUS_YES_NUM, STATUS_YES_NUMBER } from '@/utils/constants';
import logList from './components/logList';

const getDefaultForm = () => {
  return {
    code: null,
    name: null,
    remark: null,
    consultName: '',
    requiresAttach: 1,
    pay: '',
    payCode: null
  };
};

export default {
  components: { logList },
  name: 'BusinessUserRole',
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_ENABLED_NUM,
      STATUS_YES_NUM,
      STATUS_YES_NUMBER,
      queryParams: {
        prohibits: 1,
      },
      queryApi: workorderApi.ordertypeList,
      form: getDefaultForm(),
      rules: {
        consultName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        remark: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        pay: [{ required: true, message: this.$t('chooseText'), trigger: 'blur' }],
      },
      addDialogVisible: false,
      // 表单参数
      labelList: [
        { label: this.$t('table.statusText'), prop: 'prohibits', isCheck: true, disabled: false },
        { label: this.$t('WorkorderType.table.WorkorderText'), prop: 'code', isCheck: true, disabled: false },
        { label: this.$t('WorkorderType.table.InquiryType'), prop: 'consultName', isCheck: true, disabled: false },
        { label: this.$t('WorkorderType.table.ServiceType'), prop: 'name', isCheck: true, disabled: false },
        { label: this.$t('WorkorderType.table.TypeErrordescription'), prop: 'remark', isCheck: true, disabled: false, width: '250' },
        { label: this.$t('WorkorderType.table.Feeitems'), prop: 'pay', isCheck: true, disabled: false },
        { label: this.$t('WorkorderType.table.attachments'), prop: 'requiresAttach', isCheck: true, disabled: false },
        { label: this.$t('WorkorderType.table.Updatetime'), prop: 'lastUpdateDate', isCheck: true, disabled: false },
        { label: this.$t('WorkorderType.table.Updateperson'), prop: 'regenerator', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
      payList: [],
      consultNameList: []
    };
  },
  created() {
    this._getConsultationTypeList()
  },
  mounted() { },
  watch:{
    'payList'(val){
      this.form.pay = val.join(',')
    }
  },
  methods: {
    openSKU() {
      this.$refs['dialogListChangeItem'].showDialog();
    },
    onAddChargeItemConfirm(data){
      this.payList = data.map(item=> item.billCategoryName)
      this.form.payCode = (data.map(item=> item.billCategoryCode)).join(',')
    },
    changeProhibit(val){
      this.queryParams.prohibits = val;
      this.reFresh()
    },
    _getConsultationTypeList(){
      workorderApi.getConsultationTypeList().then(res=>{
        this.consultNameList = res.content.map(item => {
          return { label: item.consultName, value: item.consultName };
        });
      })
    },
    addType(){
      this.addDialogVisible = true;
      this.form = getDefaultForm();
    },
    handleClose() {
      this.payList = []
      this.addDialogVisible = false;
      this.form = getDefaultForm();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(this.form.id){
            workorderApi.ordertypeUpdate(this.form).then(()=>{
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.handleClose()
              this.reFresh()
            })
          }else{
            workorderApi.ordertypeAdd(this.form).then(()=>{
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.handleClose()
              this.reFresh()
            })
          }
        }
      });
    },
    command(TEXT, row) {
      if (TEXT === this.$t('disableText') || TEXT === this.$t('enableText')) {
        this.$confirm(`${this.$t('okText')} ${TEXT},${this.$t('WorkorderType.Workorderservicetype')}`, this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => {
          if(TEXT === this.$t('enableText')){
            workorderApi.enableOrderType({code: row.id}).then(() => {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh()
            })
          }else{
            workorderApi.forbiddenOrderType({code: row.id}).then(() => {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh()
            })
          }
        })
      }else if(TEXT === this.$t('editText')){
        this.addDialogVisible = true
        this.form = row
        this.payList = row.pay.split(',')
      }else{
        workorderApi.getOrderTypeLogsList({code: row.id}).then(res=>{
          this.$refs.logListRef.logList = res.content;
          this.$refs.logListRef.logVisible = true
        })
      }
    },
  },
};
</script>
